import { snakecase } from '@zoopla/strings';
import { DFP_TARGETING_DEFAULTS } from './constants';
import { Targeting } from './types';

/**
 * The shape of this value is most likely to be
 * boolean | number | string | null | undefined, but to cater for all
 * eventualities we use unknown and then handle each of them as well as an
 * array of unknowns and any obect. Everything except these returns an empty
 * string.
 *
 * @param  {unknown} value
 * @returns string
 */
function toString(value: unknown): string {
    if (value == null) return '';
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) return value.map(toString).join();
    if (
        typeof value === 'boolean' ||
        typeof value === 'number' ||
        typeof value === 'object'
    ) {
        return value.toString();
    }
    return '';
}

type looseObject = {
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    [k: string]: any;
};

type RawFilterFieldName = string | null;
type RawFilterOptions = null | (string | null)[];
type RawFilterValue = string | null | [] | boolean;

type RawFilter = {
    group: string | null;
    fieldName: RawFilterFieldName;
    label: string | null;
    isRequired: boolean | null;
    inputType: string | null;
    placeholder: string | null;
    allowMultiple: boolean | null;
    options: RawFilterOptions;
    value: RawFilterValue;
};

// Fix occasional issue whereby the outcodes array does not include the outcode
const coerceOutcodes = (targetingObj: Targeting): Targeting => {
    const outcodes = targetingObj['outcodes'] || [];
    if (
        Array.isArray(outcodes) &&
        typeof targetingObj['outcode'] === 'string' &&
        !outcodes.includes(targetingObj['outcode'])
    ) {
        return {
            ...targetingObj,
            outcodes: [...outcodes, targetingObj['outcode']]
        };
    }
    return targetingObj;
};

const coerceKeyValPairs = (obj: looseObject) => {
    return Object.entries(obj).reduce((result: Targeting, [key, val]) => {
        const newVal = Array.isArray(val) ? val.map(toString) : toString(val);
        return {
            ...result,
            [snakecase(key)]: newVal
        };
    }, {});
};

export const coerceDfpAdTargetingObject = (
    targetingObject?: looseObject | null
): Targeting => {
    const safelyTypedObj = targetingObject
        ? coerceKeyValPairs({ ...targetingObject })
        : {};
    return coerceOutcodes(safelyTypedObj);
};

export const mapTargetingFilters = (rawFilters: RawFilter[]) => {
    const filters = rawFilters.reduce((obj: Targeting, item) => {
        if (item.value == null) return obj;

        return {
            ...obj,
            [snakecase(toString(item.fieldName))]: toString(item.value)
        };
    }, {});

    // set defaults if empty
    return {
        ...DFP_TARGETING_DEFAULTS,
        ...filters
    };
};
